import React, { useEffect, useState } from 'react';
import { Alert, Form, Input, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import {
  loadWarehouseCorrections,
  WarehouseCorrectionSummary,
} from './warehouseCorrectionApi';

export default function WarehouseCorrectionPanel({
  documentId,
  documentType,
  editing,
  version,
}: {
  documentId: string;
  documentType: 'PZ' | 'WZ';
  editing: boolean;
  version?: string;
}) {
  const { t } = useTranslation();
  const namespace = documentType.toLowerCase();
  const [history, setHistory] = useState<WarehouseCorrectionSummary[]>([]);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true;
    loadWarehouseCorrections(documentType, documentId)
      .then((rows) => {
        if (active) {
          setHistory(rows);
          setFailed(false);
        }
      })
      .catch(() => {
        if (active) setFailed(true);
      });
    return () => {
      active = false;
    };
  }, [documentId, documentType, version]);
  return (
    <>
      {editing && (
        <>
          <Alert
            type="info"
            showIcon
            message={t(`${namespace}:correction.title`)}
            description={t(`${namespace}:correction.description`)}
          />
          <Form.Item
            name="correctionReason"
            label={t(`${namespace}:correction.reason`)}
            rules={[
              {
                required: true,
                whitespace: true,
                message: t(`${namespace}:correction.reasonRequired`),
              },
            ]}
          >
            <Input.TextArea maxLength={1000} showCount rows={2} />
          </Form.Item>
        </>
      )}
      {failed && (
        <Alert
          type="warning"
          message={t(`${namespace}:correction.historyFailed`)}
        />
      )}
      {history.length > 0 && (
        <Table
          rowKey="id"
          size="small"
          dataSource={history}
          title={() => t(`${namespace}:correction.history`)}
          pagination={{ pageSize: 5 }}
          columns={[
            {
              title: t(`${namespace}:correction.date`),
              dataIndex: 'createdAt',
              render: (date: string) => dayjs(date).format('DD.MM.YYYY HH:mm'),
            },
            {
              title: t(`${namespace}:correction.author`),
              dataIndex: 'createdByName',
            },
            { title: t(`${namespace}:correction.reason`), dataIndex: 'reason' },
          ]}
        />
      )}
    </>
  );
}
